module.exports = "<template #container></template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/vault-connection/vault-connection.component.html
// module id = 1937
// module chunks = 0